export default {"src":"/_next/static/media/accepted_fill.244a05eb.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};